import axios from 'axios';
import AuthServiceClient from './authServiceClient';
import ClientConfig from './clientConfig';

export class StefanServiceClient {
    authService = new AuthServiceClient();

    async ask(txt, threadId, callback) {

        try {
            await
                axios.get(ClientConfig.ApiBaseUrl + "ai/stefan/" + threadId + "?question=" + txt,

                    {
                        headers:
                        {
                            'Content-Type': 'application/json',
                            'Authorization': this.authService.authToken()
                        }
                    }
                ).then(response => {

                    callback(response.data);
                });
        }
        catch (e) {
            console.log('CertService error.', e);
        }
    }


}

export default StefanServiceClient;
